import env from '~/src/utils/env';

export const getTaskStatusUrl = (orgFprint: string, taskId: string) =>
  `${env.apiUrl}/clients/api/v1/org/${orgFprint}/task/${taskId}/status/`;
